import React, { createContext } from 'react';

// TypeScript interfaces for Job form context
interface JobState {
  id?: number;
  job_type_id?: number | string;
  practice_id?: number | string;
  position_type?: string;
  description?: string;
  sms_phone?: string;
  temp_date?: string | Date;
  temp_start?: string;
  temp_end?: string;
  skill_ids?: number[];
  compensation_type?: string;
  years_experience?: string;
  job_title?: string;
  experience_required?: string;
  // Set by the description writer modal after a draft is applied. Passed back to the
  // jobs controller on submit so the backend can mark the draft as accepted.
  ai_job_description_draft_id?: number;
  // Tracks which AI-generated fields the user opted into. The backend uses
  // this to confirm the draft actually drove a real change before flipping
  // `accepted=true`.
  ai_applied_fields?: string[];
  benefit_medical?: boolean;
  benefit_dental?: boolean;
  benefit_vision?: boolean;
  benefit_401k?: boolean;
  benefit_pto?: boolean;
  benefit_bonuses?: boolean;
  [key: string]: any;
}

type JobFormContextType = [
  JobState,
  React.Dispatch<React.SetStateAction<JobState>>
];

/**
 * JobForm Context - Enhanced TypeScript version
 * Provides shared state management for job form components
 * Used across multiple job creation/editing steps
 */
export const JobFormContext = createContext<JobFormContextType>([
  {} as JobState,
  () => { }
]);

// Export both named and default for compatibility
export default JobFormContext;
